import { DEFAULT_SLIDESHOW_TRANSITION } from 'ts/common/components/slideshows/slideshowTransitions';

/** Maximum number of photos/slides a slideshow may contain, enforced in both frontend and backend. */
export const MAX_SLIDESHOW_PHOTOS = 300;

export const SLIDESHOW_DEFAULTS = {
    aspectRatio: '16:9',
    slide: {
        duration: 3000,
        transition: DEFAULT_SLIDESHOW_TRANSITION,
        transitionDuration: 1000,
        backgroundColor: '#000000'
    },
    item: {
        rotation: 0,
        positionX: 0,
        positionY: 0,
        width: 100,
        height: 100
    }
} as const;

export function normalizeBackgroundColor(color: string | null | undefined): string {
    const value = color ?? SLIDESHOW_DEFAULTS.slide.backgroundColor;

    return (value.startsWith('#') ? value : `#${value}`).toLowerCase();
}

export function getSlideBackgroundColor(slide: SpApi.ISlideshowSlide | undefined): string {
    return normalizeBackgroundColor(slide?.backgroundColor);
}
